// ** React Imports
import React from 'react'

// ** Child Imports
import AnalyticsDataWidget from '../visualizations/AnalyticsDataWidget'

// ** Types Imports
import { WidgetType } from 'src/lib/types/dashboardAnalytics'

// ** Util Imports
import { initialOrdersWidgetData, ordersWidgetsConfig } from 'src/assets/AnalyticsConfig'
import { analyticsConstants } from 'src/lib/utils/constants'

const OrderDataWidget: React.FC<WidgetType> = ({ 
    value,
    isLoading,
    id,
    hasComparison,
    moreIsGood
}) => {
    const getCurrentWidgetIndex = () => {
        switch (id) {
            case `${analyticsConstants.FLO_ORDERS}_total`:
                return hasComparison ? 3 : 0;
            case  `${analyticsConstants.FLO_ORDERS}_sales`:
                return hasComparison ? 4 : 1;
            case `${analyticsConstants.FLO_ORDERS}_aov`:
                return hasComparison ? 5 : 2;
            default: return hasComparison ? 3 : 0;
        }
    }

    const getCompareToIndex = () => {
        switch (id) {
            case `${analyticsConstants.FLO_ORDERS}_total`:
                return 0;
            case  `${analyticsConstants.FLO_ORDERS}_sales`:
                return 1;
            case `${analyticsConstants.FLO_ORDERS}_aov`:
                return 2;
            default: return 1;
        }
    }

    const currentValue = value ?? initialOrdersWidgetData?.data?.widgetData;
    const currentIndex = getCurrentWidgetIndex();
    const compareToIndex = getCompareToIndex();

    const fontProperties = {
        fontSize: 28,
        fontWeight: 600,
        fontColor: "#4D4D4D",
        lineHeight: '36px'
    }

    return (
        <AnalyticsDataWidget
            hideBorders
            widgetType={ordersWidgetsConfig?.[currentIndex]?.widgetType} 
            valueType={ordersWidgetsConfig?.[currentIndex]?.valueType} 
            widgetWidth={"100%"}
            widgetHeight={50}
            fontProperties={fontProperties}
            value={currentValue?.[currentIndex]?.x ?? "0"}
            {... (hasComparison ? {compareToValue: currentValue?.[compareToIndex]?.compare_to_x ?? "0"}: {})}
            isLoading={isLoading}
            removeInnerPadding
            cardVariant='outlined'
            moreIsGood={moreIsGood}
        />
  )
}

export default OrderDataWidget

            